"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiConfirmContentPropsSx = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const styles_1 = require("@mui/material/styles");
const material_ui_confirm_1 = require("material-ui-confirm");
const notistack_1 = require("notistack");
require("@@/common/css/reset.css");
require("@@/common/css/default.css");
require("@@/common/css/typography.css");
require("@@/common/css/palette.css");
require("@@/common/css/toast-message.css");
let theme = (0, styles_1.createTheme)({
    palette: {
        primary: { main: '#ee8844' },
        primary_dark: { main: '#ee7744' },
        secondary: { main: '#000' },
        info: { main: '#fff' },
        warning: { main: '#eb5757' },
    },
});
theme = (0, styles_1.createTheme)(theme, {
    typography: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Spoqa Han Sans", "Spoqa Han Sans JP", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    },
    breakpoints: { values: { xs: 0 } },
    components: {
        MuiGrid: {
            styleOverrides: {
                container: { flexShrink: 0 },
                item: { lineHeight: 1 },
            },
        },
        MuiButtonBase: { styleOverrides: { root: { '&:focus': { outline: 'none !important' } } } },
        MuiButton: {
            styleOverrides: {
                root: {
                    minWidth: 0,
                    lineHeight: 1,
                    fontWeight: 400,
                    fontSize: '14px',
                    textTransform: 'none',
                    '&:focus': { outline: 'none' },
                },
            },
            variants: [
                {
                    props: { variant: 'orange_filled' },
                    style: {
                        height: '50px',
                        padding: '6px',
                        borderRadius: '6px',
                        backgroundColor: `${theme.palette.primary.main} !important`,
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: 700,
                    },
                },
                {
                    props: { variant: 'grey_outlined' },
                    style: {
                        height: '50px',
                        padding: '6px',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        backgroundColor: 'white !important',
                        color: theme.palette.secondary.main,
                        fontSize: '16px',
                        fontWeight: 700,
                    },
                },
                {
                    props: { variant: 'black_outlined_small' },
                    style: {
                        height: '24px',
                        padding: '5px 8px',
                        border: '1px solid black',
                        backgroundColor: 'white !important',
                        color: 'black !important',
                        fontSize: '12px',
                    },
                },
            ],
        },
        MuiMenu: {
            defaultProps: { PaperProps: { elevation: 0 } },
            styleOverrides: {
                paper: { boxShadow: '0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 20%)' },
                list: { padding: 0 },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: { minHeight: 0, '&:hover': { backgroundColor: 'rgba(248, 248, 248, 0.5)' } },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: { lineHeight: 1, textTransform: 'none', '&:focus': { outline: 'none' } },
            },
        },
        MuiIconButton: { styleOverrides: { root: { padding: '4px', '&:focus': { outline: 'none' } } } },
        MuiRadio: {
            styleOverrides: {
                root: { width: '25px', height: '25px', color: 'rgba(0, 0, 0, 0.1)' },
            },
        },
        MuiCheckbox: { defaultProps: { color: 'secondary' } },
        MuiTooltip: {
            styleOverrides: {
                tooltip: { fontWeight: 400, fontSize: '11px', cursor: 'unset', lineHeight: 1.2 },
            },
        },
        MuiDialog: {
            defaultProps: { slotProps: { backdrop: { sx: { bgcolor: 'var(--gray-20)' } } } },
            styleOverrides: { paperScrollPaper: { maxHeight: 'none' } },
        },
        MuiTabs: { styleOverrides: { root: { minHeight: 0 } } },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: '42px',
                    maxHeight: '64px',
                    padding: '4px 0',
                    '&:focus': { outline: 'none !important' },
                },
            },
        },
        MuiNativeSelect: {
            styleOverrides: { select: { '&:focus': { background: 'none !important' } } },
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    '&::before': { border: '0 !important' },
                    '&::after': { border: '0 !important' },
                    '&::hover': { border: '0' },
                },
            },
        },
        MuiSvgIcon: { styleOverrides: { root: { width: '20px', height: '20px' } } },
    },
});
exports.muiConfirmContentPropsSx = {
    minHeight: '82px',
    padding: '14px 14px 16px',
    '.MuiDialogContentText-root': {
        fontSize: '16px',
        lineHeight: '26px',
        color: 'rgba(0, 0, 0, 0.8)',
        wordBreak: 'keep-all',
    },
    '+ .MuiDialogActions-root': {
        justifyContent: 'space-between',
        columnGap: '8px',
        padding: '0px 14px 14px',
        '> button:not(:first-of-type)': { marginLeft: 0 },
    },
};
function default_1({ children }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const notistackRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(styles_1.ThemeProvider, Object.assign({ theme: theme }, { children: (0, jsx_runtime_1.jsx)(material_ui_confirm_1.ConfirmProvider, Object.assign({ defaultOptions: {
                title: '',
                confirmationText: t('확인'),
                cancellationText: t('취소'),
                dialogProps: {
                    slotProps: { backdrop: { sx: { bgcolor: 'var(--gray-20)' } } },
                    transitionDuration: 225,
                    PaperProps: { sx: { maxWidth: '374px', borderRadius: '16px' } },
                },
                contentProps: {
                    sx: exports.muiConfirmContentPropsSx,
                },
                cancellationButtonProps: {
                    variant: 'grey_outlined',
                    sx: {
                        flex: 1,
                        height: '40px',
                        borderRadius: '8px',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        fontWeight: 'normal',
                        color: 'rgba(0, 0, 0, 0.8)',
                    },
                },
                confirmationButtonProps: {
                    variant: 'orange_filled',
                    sx: { flex: 1, height: '40px', borderRadius: '8px' },
                },
            } }, { children: (0, jsx_runtime_1.jsx)(notistack_1.SnackbarProvider, Object.assign({ ref: notistackRef, onClose: (_, reason, key) => {
                    if (notistackRef.current && reason === 'clickaway') {
                        notistackRef.current.closeSnackbar(key);
                    }
                }, dense: true, maxSnack: 9, domRoot: document.getElementById('root') || undefined }, { children: children })) })) })));
}
exports.default = default_1;
